import React, { FC } from 'react';
import Alert, { AlertHeading } from '../components/bootstrap/Alert';
import Modal from '../components/bootstrap/Modal';
// import useEventListener from '../hooks/useEventListener';
import { useNavigate } from 'react-router-dom';

interface IModalProps {
	isOpen: boolean;
	alertStatus: any;
	setIsOpen(...args: unknown[]): unknown;
	isNavigate?: any | undefined;
}

const AlertService: FC<IModalProps> = ({ setIsOpen, isOpen, alertStatus, isNavigate }) => {

	const navigate = useNavigate();

	// For Mobile view alert close
	function closeModal() {
		setIsOpen(false);
		if (isNavigate != null) {
			navigate(isNavigate);
		}
	}


	// useEventListener('mousedown', closeModal);
	// useEventListener('touchstart', closeModal);
	// useEventListener('touchmove', closeModal);
	// useEventListener('touchend', closeModal);

	return (
		<>
			{alertStatus.type == 'success' ? (
				<Modal
					isOpen={isOpen}
					setIsOpen={setIsOpen}
					titleId='addAcademicPeriod'
					isCentered
					isAnimation={false}
					isStaticBackdrop={true}
					isNavigate={isNavigate}>
					<></>
					<Alert
						style={{ marginBottom: '0px', position: 'relative' }}
						color='success'
						shadow='md'
						isLight
						icon='Recommend'
						className='flex-nowrap'>
						<button
							type='button'
							className='btn-close'
							aria-label='Close'
							onClick={closeModal}
							style={{ position: 'absolute', top: '1rem', right: '1rem', transform: 'scale(0.75)' }}
						/>
						<div>
							<AlertHeading>Well Done!</AlertHeading>
							<p className='mt-6'>{alertStatus.message}</p>
						</div>
					</Alert>
				</Modal>
			) : alertStatus.type == 'warning' ? (
				<Modal
					isOpen={isOpen}
					setIsOpen={setIsOpen}
					titleId='addAcademicPeriod'
					isCentered
					isAnimation={false}
					isStaticBackdrop={true}
					isNavigate={isNavigate}>
					<></>
					<Alert
						style={{ marginBottom: '0px', position: 'relative' }}
						color='warning'
						shadow='md'
						isLight
						icon='Report'
						className='flex-nowrap'>
						<button
							type='button'
							className='btn-close'
							aria-label='Close'
							onClick={closeModal}
							style={{ position: 'absolute', top: '1rem', right: '1rem', transform: 'scale(0.75)' }}
						/>
						<div>
							<AlertHeading>Warning!</AlertHeading>
							<p className='mt-6'>{alertStatus.message}</p>
						</div>
					</Alert>
				</Modal>
			) : (
				<Modal
					isOpen={isOpen}
					setIsOpen={setIsOpen}
					titleId='addAcademicPeriod'
					isCentered
					isAnimation={false}
					isStaticBackdrop={true}
					isNavigate={isNavigate}>
					<></>
					<Alert
						style={{ marginBottom: '0px', position: 'relative' }}
						color='danger'
						shadow='md'
						isLight
						icon='Report'
						className='flex-nowrap'>
						<button
							type='button'
							className='btn-close'
							aria-label='Close'
							onClick={closeModal}
							style={{ position: 'absolute', top: '1rem', right: '1rem', transform: 'scale(0.75)' }}
						/>
						<div>
							<AlertHeading>Error!</AlertHeading>
							<p className='mt-6'>{alertStatus.message}</p>
						</div>
					</Alert>
				</Modal>
			)}
		</>
	);
};

export default AlertService;
